module.exports = __webpack_public_path__ + "media/tolmex/bghead-2d380f6e.png";